import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

const BASE_URL   = process.env.VUE_APP_I18N_BASE_URL
const DEFAULT    = process.env.VUE_APP_I18N_DEFAULT_LANG || 'es'
const CACHE_TTL  = 1000 * 60 * 30 // 30 minutes

const LS_PREFIX = 'i18n_msgs_'
const LS_META   = 'i18n_meta_'

const i18n = new VueI18n({
  locale: DEFAULT,
  fallbackLocale: DEFAULT,
  messages: {},
  silentTranslationWarn: true,
})

function cacheKey(lang) { return `${LS_PREFIX}${lang}` }
function metaKey(lang)  { return `${LS_META}${lang}`  }

function getCached(lang) {
  try {
    const raw = localStorage.getItem(cacheKey(lang))
    const metaRaw = localStorage.getItem(metaKey(lang))
    if (!raw || !metaRaw) return null
    const meta = JSON.parse(metaRaw)
    if (Date.now() - meta.ts > CACHE_TTL) return null
    return { messages: JSON.parse(raw), meta }
  } catch { return null }
}

function setCached(lang, messages, etag) {
  localStorage.setItem(cacheKey(lang), JSON.stringify(messages))
  localStorage.setItem(metaKey(lang), JSON.stringify({ etag: etag || null, ts: Date.now() }))
}

async function fetchRemoteMessages(lang) {
  const url = `${BASE_URL}.${lang}.i18n.json`
  const headers = {}
  const meta = JSON.parse(localStorage.getItem(metaKey(lang)) || '{}')
  if (meta.etag) headers['If-None-Match'] = meta.etag

  try {
    const res = await axios.get(url, { headers, validateStatus: s => (s >= 200 && s < 300) || s === 304 })
    if (res.status === 304) {
      const cached = getCached(lang)
      return cached ? cached.messages : {}
    }
    const etag = res.headers.etag || res.headers.ETag
    const msgs = res.data || {}
    setCached(lang, msgs, etag)
    return msgs
  } catch (e) {
    const cached = getCached(lang)
    if (cached) return cached.messages
    console.error('[i18n] fetch error and no cache available', e)
    return {}
  }
}

const loaded = Object.create(null)

export async function loadLanguageAsync(lang) {
  if (loaded[lang]) {
    i18n.locale = lang
    document.documentElement.setAttribute('lang', lang)
    localStorage.setItem('lang', lang)
    return lang
  }
  const msgs = await fetchRemoteMessages(lang)
  i18n.setLocaleMessage(lang, msgs)
  i18n.locale = lang
  loaded[lang] = true
  document.documentElement.setAttribute('lang', lang)
  localStorage.setItem('lang', lang)
  return lang
}

export default i18n
